import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

import { partial } from '../../../util/translation/translation';

const TimeframeSelector = ({ timeframe, onTimeframeChange }) => {
  const a = partial('Analytics');

  return (
    <Nav pills>
      {['7days', '1month', '3months', 'Custom'].map((tf) => (
        <NavItem key={tf}>
          <NavLink
            role="button"
            onClick={() => onTimeframeChange(tf)}
            active={tf === timeframe}
          >
            {tf === '7days'
              ? a('7Days')
              : tf === '1month'
                ? a('1Month')
                : tf === '3months'
                  ? a('3Months')
                  : a('custom')}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default TimeframeSelector;
